import React, { useEffect, useState } from "react";
import { adminServices } from "../services/AdminServices";
import Button2 from "../components/Button2";
import DataTable from "react-data-table-component";
import ConfirmationDialog from "../components/ConfirmationDialog";
import AlertModal from "../components/AlertModal";
import { Navigate, redirect, Route } from "react-router-dom";
import { ReactComponent as ProfileIcon } from "../icons/profile-view.svg";
import { ReactComponent as BackIcon } from "../icons/back.svg";
import { useNavigate } from 'react-router-dom';
import LoadingModal from "../components/LoadingModal";
import VoidModal from "./VoidModal";
import SearchBar from "../components/SearchBar";
import UnauthorizedComponent from "../components/UnauthorizedComponent";
import Button from "../components/Button";
import { v4 as uuidv4 } from 'uuid';
import InputText1 from "../components/InputText1";
import Modal from "react-modal";
import withAuthorization from "../components/withAuthorization";
import { formatCurrency } from "../tools/tool";
import { toast } from "react-toastify";
import { jwtDecode } from "jwt-decode";
import Dropdown from "../components/Dropdown";
import { dltService } from "../services/DltService";
const customStyles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.75)'
  },
  content: {
    width: '35%',
    margin: 'auto',
    height: '100%',
    backgroundColor: 'transparent',
    border: 0
  }
};
const OptionRemarks = [{
  value: "",
  label: "Select a reason"
}, {
  value: "For Realeased PDL",
  label: "For Realeased PDL"
}, {
  value: "For Deceased PDL",
  label: "For Deceased PDL"
}, {
  value: "Others",
  label: "Others"
}];
const PDLTransactions = () => {
  const navigate = useNavigate();
  const [pdlNumber, setPdlNumber] = useState('');
  const [firstName, setFirstName] = useState('');
  const [walletAmount, setWalletAmount] = useState(0);
  const [lastName, setLastName] = useState('');
  const [middleName, setMiddleName] = useState('');
  const [gender, setGender] = useState('');
  const [dob, setDob] = useState('');
  const [facilityNumber, setFacilityNumber] = useState('');
  const [quadrant, setQuadrant] = useState('');
  const [pin, setPin] = useState('');
  const [statusId, setStatusId] = useState(1);
  const [options, setOptions] = useState([]);
  const [transactions, setTransactions] = useState(null);
  const [columns, setColumns] = useState([]);
  const [suffix, setSuffix] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [showAlert2, setShowAlert2] = useState(false);
  const [alertMessage2, setAlertMessage2] = useState('');
  const [selectedRemark, setSelectedRemark] = useState('Select a reason');
  const [colonies, setColonies] = useState([]);
  const [colonyId, setColonyId] = useState(0);
  const [attachmentRelease, setAttachmentRelease] = useState('');
  const [attachmentVoid, setAttachmentVoid] = useState('');
  const [attachmentContentType, setAttachmentContentType] = useState('');
  const [fileExtension, setFileExtension] = useState('');
  const [customSpendingLimit, setCustomSpendingLimit] = useState(0);
  const [isAdmin, setIsAdmin] = useState(false);
  const [mode, setMode] = useState('all');
  const [isReset, setIsReset] = useState(false);
  const [noPin, setNoPin] = useState(false);
  const [showVoid, setShowVoid] = useState(false);
  const [voidRefNo, setVoidRefNo] = useState('');
  const [makeTransfer, setMakeTransfer] = useState(false);
  const [transferAmount, setTransferAmount] = useState(0);
  const [formSeqNo, setFormSeqNo] = useState("");
  const [validationMessage, setValidationMessage] = useState("");
  const [isValidated, setIsValidate] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [settingData, setSettingData] = useState({});
  const [confirmVoid, setConfirmVoid] = useState(false);
  const [voidMessage, setVoidMessage] = useState('');
  const [toVoid, setToVoid] = useState({});
  const [loading, setLoading] = useState(false);
  const [remark, setRemark] = useState('');
  const [locked, setLocked] = useState(false);
  const threeDaysAgo = new Date();
  threeDaysAgo.setDate(threeDaysAgo.getDate() - 3);
  const data = JSON.parse(atob(localStorage.getItem('selectedPDL')));
  const limit = 100;
  const [offset, setOffset] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [totalRangeAmount, setTotalRangeAmount] = useState(0);
  const [facilities, setFacilities] = useState([]);
  const [dltStatus, setDltStatus] = useState({
    label: "Checking DLT...",
    tone: "checking",
    message: "Checking chain integrity"
  });
  useEffect(() => {
    getConfig();
    getColonies();
  }, []);
  useEffect(() => {
    if (settingData) {
      var token = localStorage.getItem("appToken");
      setIsAdmin(jwtDecode(token)["isAdmin"] === "1");

      //getData();
      setLoading(true);
      setPdlNumber(data.pdlNumber);
      setFirstName(data.firstName);
      setMiddleName(data.middleName);
      setWalletAmount(data.walletAmount);
      setLastName(data.lastName);
      setDob(data.dob);
      setFacilityNumber(data.facilityNumber);
      setGender(data.gender);
      setStatusId(data.statusId);
      setQuadrant(data.quadrant);
      setColonyId(data.colonyId);
      getClientStatuses();
      getClientTransactions();
      setSuffix(data.suffix);

      // alert(settingData.spending_limit);

      setCustomSpendingLimit(data.customSpendingLimit == null ? settingData.spending_limit : data.customSpendingLimit);
      if (data.leftFingerPrint === null && data.rightFingerPrint === null && (data.pin == null || data.pin === '3973e022e93220f9212c18d0d0c543ae7c309e46640da93a4a0314de999f5112')) {
        setLocked(true);
      }
      if (data.leftFingerPrint != null && data.rightFingerPrint != null) {
        setNoPin(true);
      }
    }
  }, [settingData]);
  useEffect(() => {
    if (offset) {
      if (mode == "all") {
        getClientTransactions();
        return;
      }
      if (mode == "purchases") {
        getClientPurchases();
        return;
      }
      if (mode == "padala") {
        getClientPadala();
        return;
      }
    }
  }, [offset]);
  useEffect(() => {
    if (!pdlNumber) {
      return;
    }
    getDltStatus(pdlNumber);
  }, [pdlNumber]);
  useEffect(() => {
    if (colonyId && colonies.length > 0) {
      let quad = quadrant;
      let fac = JSON.parse(colonies.find(c => c.colony_id == colonyId)?.facilities) || [];
      //console.log(fac);

      const defaultOption = {
        Facility: 'Not Applicable',
        FacilityId: 'N/A'
      };
      setFacilities([defaultOption, ...fac]);
      setQuadrant(quad);
    }
  }, [colonies, colonyId]);
  const getColonies = async () => {
    var form = new FormData();
    form.append('params', '');
    try {
      const response = await adminServices.storeProcedure2("getColonies", {});
      setColonies(response.data);
    } catch (e) {}
  };
  const getConfig = async () => {
    var form = new FormData();
    form.append('params', '');
    try {
      const response = await adminServices.storeProcedure2("get_settings", {});
      const settingsData = response.data;
      setSettingData(settingsData[0]);
    } catch (e) {
      //console.log(e);
      if (e && e.response && e.response.status === 401) {
        window.location.href = "/";
      }
    } finally {
      setLoading(false);
    }
  };
  const updateClient = async () => {
    if (firstName === '') {
      setShowConfirm(false);
      setAlertMessage("First Name is required");
      setShowAlert(true);
      return;
    }
    if (middleName === '') {
      setShowConfirm(false);
      setAlertMessage("Middle Name is required");
      setShowAlert(true);
      return;
    }
    if (lastName === '') {
      setShowConfirm(false);
      setAlertMessage("Last Name is required");
      setShowAlert(true);
      return;
    }
    const age = new Date().getFullYear() - new Date(dob).getFullYear();
    if (age < 18) {
      setShowConfirm(false);
      setAlertMessage("Age must be at least 18 years old");
      setShowAlert(true);
      return;
    }
    if (facilityNumber === '') {
      setShowConfirm(false);
      setAlertMessage("Facility Number is required");
      setShowAlert(true);
      return;
    }
    var form = data;
    form.firstName = firstName;
    form.middleName = middleName;
    form.lastName = lastName;
    form.dob = dob;
    form.gender = gender;
    form.facilityNumber = facilityNumber;
    form.pin = pin == '' ? data.pin : pin;
    form.statusId = statusId;
    form.leftFingerPrint = data.leftFingerPrint;
    form.rightFingerPrint = data.rightFingerPrint;
    form.quadrant = quadrant;
    form.customSpendingLimit = customSpendingLimit;
    form.colonyId = colonyId;
    form.suffix = suffix;
    form.compound = data.compound;
    form.regdate = new Date();
    delete form.walletAmount;
    setShowConfirm(false);
    await adminServices.updatePDL(form).then(r => {
      if (r.status === 204) {
        var append = pin != '' ? "\n\rTemporary PIN: " + pin + ", kindly take note" : "";
        setAlertMessage("PDL Profile Updated" + append);
        setShowAlert(true);
        toast.success("PDL Profile has been updated successfully");
      }
    }).catch(e => {
      if (e.response && e.response.status === 401) {
        window.location.href = "/";
      } else {
        setAlertMessage(e.response ? e.response.message : "Error updating profile");
        setShowAlert(true);
      }
    });
  };
  const getClientStatuses = async () => {
    var form = new FormData();
    form.append('params', '');
    await adminServices.storeProcedure2('get_client_statuses', {}).then(r => {
      setOptions(r.data);
    }).catch(e => {
      if (e.response.status === 401) {
        window.location.href = '/';
      }
    });
  };
  const getDltStatus = async identifier => {
    setDltStatus({
      label: "Checking DLT...",
      tone: "checking",
      message: "Checking chain integrity"
    });
    try {
      const response = await dltService.checkChainIntegrity(identifier);
      const payload = response?.data;
      if (payload?.balanceVerification?.balanceHashValid && payload?.valid) {
        setDltStatus({
          label: "DLT Verified",
          tone: "valid",
          message: payload?.message || "Chain integrity verified"
        });
        return;
      }
      setDltStatus({
        label: "Balance has been tampered",
        tone: "invalid",
        message: payload?.message || "Chain integrity failed"
      });
    } catch (error) {
      setDltStatus({
        label: "DLT Unavailable",
        tone: "error",
        message: error?.response?.data?.message || "Unable to verify chain integrity"
      });
    }
  };
  const handleButtonClick = e => {
    setToVoid(e);
    // setVoidMessage("Are you sure you want to void this transaction?\n\r" + `${ e.transaction_type} : ${e.amount.toLocaleString('en-US', {
    //     minimumFractionDigits: 2,
    //     maximumFractionDigits: 2,
    //   })}`);
    // setConfirmVoid(true);
    setShowVoid(true);
    //console.log(e);
    setVoidRefNo(e.refNo);

    //console.log(e);
  };
  const getClientTransactions = async () => {
    setTotalRangeAmount(0);
    setLoading(true);
    // form.append('params',`${data.id},${limit},${offset}`);
    setColumns([]);
    // include optional date range params startDate and endDate
    let qs = `id=${data.id}&limit=${limit}&offset=${offset}`;
    if (startDate) qs += `&startDate=${startDate}`;
    if (endDate) qs += `&endDate=${endDate}`;
    await adminServices.getData(`tx/client-transactions?${qs}`).then(r => {
      if (r.status === 200) {
        setTotalRecords(r.data.totalRecords);
        setTransactions(r.data.transactions);
        setFilteredData(r.data.transactions);
        // compute total amount for the returned range
        const total = (r.data.transactions || []).reduce((s, it) => s + Math.abs(it.amount || 0), 0);
        setTotalRangeAmount(total);
        var _col = [{
          name: 'ID',
          selector: data => data.id,
          sortable: true,
          width: '75px'
        }, {
          name: 'Date',
          selector: data => new Date(data.timestamp).toLocaleString(),
          sortable: true
        }, {
          name: 'Type',
          selector: data => data.transactionType,
          sortable: true,
          width: '100px'
        }, {
          name: 'Reference No',
          selector: data => data.refNo,
          sortable: true,
          width: '150px'
        }, {
          name: 'Amount',
          selector: data => formatCurrency(data.amount),
          sortable: true,
          right: true,
          headerStyle: {
            textAlign: 'center'
          }
        }, {
          name: 'Remarks',
          selector: data => data.remarks,
          sortable: true
        }, {
          name: 'Action',
          cell: row => {
            const timestampDate = new Date(row.txDate);
            const cashOut = [8, 9, 10].includes(row.transactionTypeId);
            if (cashOut) {
              return "";
            }
            return timestampDate > threeDaysAgo && row.voided === 0 && !row.remarks?.startsWith("Data correction.") ? <button type="button" onClick={() => handleButtonClick(row)}>Void</button> : null;
          },
          sortable: false
        }];
        setColumns(_col);
        setLoading(false);
      }
    }).catch(e => {
      if (e.status === 401) {
        window.location.href = '/';
      }
      if (e.status === 404) {
        setTransactions([]);
        setLoading(false);
      }
    });
  };
  const getClientPurchases = async () => {
    setTotalRangeAmount(0);
    setLoading(true);
    // include startDate/endDate if provided
    let qs = `id=${data.id}&limit=${limit}&offset=${offset}`;
    if (startDate) qs += `&startDate=${startDate}`;
    if (endDate) qs += `&endDate=${endDate}`;
    await adminServices.getData(`tx/client-purchases?${qs}`).then(r => {
      setTotalRecords(r.data.totalRecords);
      setTransactions(r.data.transactions);
      setFilteredData(r.data.transactions);
      setColumns([]);
      const total = (r.data.transactions || []).reduce((s, it) => s + Math.abs(it.amount || 0), 0);
      setTotalRangeAmount(total);
      var _col = [{
        name: 'ID',
        selector: data => data.id,
        sortable: true,
        width: '75px'
      }, {
        name: 'Date',
        selector: data => new Date(data.timestamp).toLocaleString(),
        sortable: true
      }, {
        name: 'Type',
        selector: data => data.transactionType,
        sortable: true,
        width: '100px'
      }, {
        name: 'Reference No',
        selector: data => data.refNo,
        sortable: true,
        width: '150px'
      }, {
        name: 'Amount',
        selector: data => formatCurrency(data.amount),
        sortable: true,
        right: true,
        headerStyle: {
          textAlign: 'center'
        }
      }, {
        name: 'Remarks',
        selector: data => data.remarks,
        sortable: true
      }, {
        name: 'Action',
        cell: row => {
          const timestampDate = new Date(row.txDate);
          const cashOut = [8, 9, 10].includes(row.transactionTypeId);
          if (cashOut) {
            return "";
          }
          return timestampDate > threeDaysAgo && row.voided === 0 && !row.remarks?.startsWith("Data correction.") ? <button type="button" onClick={() => handleButtonClick(row)}>Void</button> : null;
        },
        sortable: false
      }];
      setColumns(_col);
      setLoading(false);
    }).catch(e => {
      if (e.status === 401) {
        window.location.href = '/';
      }
      if (e.status === 404) {
        setTransactions([]);
        setLoading(false);
      }
    });
  };
  const getClientPadala = async () => {
    setLoading(true);
    setTotalRangeAmount(0);
    var form = new FormData();
    form.append('params', data.id);
    setColumns([]);
    // include startDate/endDate if provided
    let qs = `id=${data.id}&limit=${limit}&offset=${offset}`;
    if (startDate) qs += `&startDate=${startDate}`;
    if (endDate) qs += `&endDate=${endDate}`;
    await adminServices.getData(`tx/client-padala?${qs}`).then(r => {
      setTotalRecords(r.data.totalRecords);
      setTransactions(r.data.transactions);
      setFilteredData(r.data.transactions);
      const total = (r.data.transactions || []).reduce((s, it) => s + Math.abs(it.amount || 0), 0);
      setTotalRangeAmount(total);
      var _col = [{
        name: 'ID',
        selector: data => data.id,
        sortable: true,
        width: '75px'
      }, {
        name: 'Date',
        selector: data => new Date(data.timestamp).toLocaleString(),
        sortable: true,
        width: '200px'
      }, {
        name: 'Type',
        selector: data => data.transactionType,
        sortable: true
      }, {
        name: 'Reference No',
        selector: data => data.refNo,
        sortable: true
      }, {
        name: 'Net Amount',
        selector: data => formatCurrency(data.netAmount),
        sortable: true,
        right: true,
        headerStyle: {
          textAlign: 'center'
        }
      }, {
        name: 'Interest Rate',
        selector: data => formatCurrency(data.interestRate),
        sortable: true,
        right: true,
        headerStyle: {
          textAlign: 'center'
        }
      }, {
        name: 'Gross Amount',
        selector: data => formatCurrency(data.grossAmount),
        sortable: true,
        right: true,
        headerStyle: {
          textAlign: 'center'
        }
      }, {
        name: 'Bank Reference',
        selector: data => data.bankReference,
        sortable: true
      }, {
        name: 'Remarks',
        selector: data => data.remarks + "-" + data.bankReference,
        sortable: true
      }, {
        name: 'Action',
        cell: row => {
          const timestampDate = new Date(row.txDate);
          const cashOut = [8, 9, 10].includes(row.transactionTypeId);
          if (cashOut) {
            return "";
          }
          return timestampDate > threeDaysAgo && row.voided === 0 && !row.remarks?.startsWith("Data correction.") ? <button type="button" onClick={() => handleButtonClick(row)}>Void</button> : null;
        },
        sortable: false
      }];
      setColumns(_col);
      setLoading(false);
    }).catch(e => {
      if (e.status === 401) {
        window.location.href = '/';
      }
      if (e.status === 404) {
        setTransactions([]);
        setLoading(false);
      }
    });
  };
  const getClientVoids = async () => {
    setLoading(true);
    setTotalRangeAmount(0);
    try {
      // include startDate/endDate if provided
      let qs = `id=${data.id}&limit=${limit}&offset=${offset}`;
      if (startDate) qs += `&startDate=${startDate}`;
      if (endDate) qs += `&endDate=${endDate}`;
      // call the voids endpoint for this client
      const resp = await adminServices.getData(`tx/voids?${qs}`);
      if (resp.status === 200) {
        setTotalRecords(resp.data.totalRecords || 0);
        setTransactions(resp.data.transactions || []);
        setFilteredData(resp.data.transactions || []);
        // compute total amount for returned voids
        const total = (resp.data.transactions || []).reduce((s, it) => s + Math.abs(it.amount || 0), 0);
        setTotalRangeAmount(total);
        setColumns([]);
        var _col = [{
          name: 'ID',
          selector: d => d.id,
          sortable: true,
          width: '75px'
        }, {
          name: 'Date',
          selector: d => new Date(d.timestamp).toLocaleString(),
          sortable: true
        }, {
          name: 'Type',
          selector: d => d.transactionType || d.transaction_type,
          sortable: true,
          width: '100px'
        }, {
          name: 'Reference No',
          selector: d => d.refNo || d.ref_no,
          sortable: true,
          width: '150px'
        }, {
          name: 'Amount',
          selector: d => formatCurrency(d.amount),
          sortable: true,
          right: true
        }, {
          name: 'Remarks',
          selector: d => d.remarks || d.reason,
          sortable: true
        }];
        setColumns(_col);
      }
    } catch (e) {
      if (e.status === 401 || e.response && e.response.status === 401) {
        window.location.href = "/";
      }
      if (e.status === 404 || e.response && e.response.status === 404) {
        setTransactions([]);
        setFilteredData([]);
      }
    } finally {
      setLoading(false);
    }
  };
  const applyDateFilter = async () => {
    setOffset(0);
    if (mode === 'all') await getClientTransactions();else if (mode === 'padala') await getClientPadala();else if (mode === 'purchases') await getClientPurchases();else if (mode === 'void') await getClientVoids();
  };
  const voidTransaction = async () => {
    var form = {
      "id": toVoid.id,
      "clientId": toVoid.clientId,
      "transactionTypeId": toVoid.transactionTypeId == 3 ? 5 : 4,
      "refNo": toVoid.refNo,
      "amount": toVoid.amount,
      "remarks": "Voided;" + toVoid.remarks,
      "timestamp": toVoid.timestamp
    };
    await adminServices.updateClientTransaction(form).then(async r => {
      if (r.status == 204) {
        navigate("/pdl-management");
      }
    }).catch(e => {
      if (e.response.status != 401) {
        setAlertMessage("Error Voiding Transaction");
        setShowAlert(true);
        setConfirmVoid(false);
      } else {
        window.location.href = "/";
      }
    });
  };
  const generateRandomNumber = () => {
    const min = 100000;
    const max = 999999;
    const number = Math.floor(Math.random() * (max - min + 1)) + min;
    return number;
  };
  const handleTransfer = () => {
    if (data.walletAmount <= 0) {
      setAlertMessage("PDL Wallet Balance is 0. Cannot do Cash Out Request");
      setShowAlert(true);
      return;
    }
    setMakeTransfer(true);
  };
  const validateForm = () => {
    if (transferAmount <= 0) {
      setIsValidate(false);
      //   setValidationMessage("Cash Out Amount should be at least 1");
      setShowAlert2(true);
      setAlertMessage2("Cash Out Amount should be at least 1");
      return false;
    }
    if (transferAmount > data.walletAmount) {
      // setIsValidate(false);
      // setValidationMessage("Cash Out Amount cannot be greater than PDL Wallet");
      setShowAlert2(true);
      setAlertMessage2("Cash Out Amount cannot be greater than PDL Wallet");
      return false;
    }
    if (formSeqNo === "") {
      setIsValidate(false);
      // setValidationMessage("Form Sequence Number Required.");
      setShowAlert2(true);
      setAlertMessage2("Form Sequence Number Required.");
      return false;
    }
    if (selectedRemark === "Select a reason") {
      setIsValidate(false);
      // setValidationMessage("Please select a reason");
      setShowAlert2(true);
      setAlertMessage2("Please select a reason");
      return false;
    } else {
      if (selectedRemark == "Others") {
        if (remark === "") {
          setIsValidate(false);
          setShowAlert2(true);
          setAlertMessage2("Specify a reason");
          return false;
        }
      }
    }
    if (attachmentRelease === '') {
      setIsValidate(false);
      setValidationMessage("Please attach required document");
      return false;
    }
    return true;
  };
  const handleSubmit = async () => {
    if (validateForm()) {
      setLoading(true);
      await dltService.postCashout("", {
        userId: pdlNumber,
        amount: transferAmount
      }).then(async r => {
        if (r.status === 200) {
          if (r.data.status === "accepted") {
            let uuid = uuidv4();
            let refNo = uuid.split('-')[4];
            let remarks = "Cash Out Request SQN: " + formSeqNo + ";PDL Number: " + pdlNumber + `(${firstName} ${lastName});Remarks: ${remark || selectedRemark}`;
            await adminServices.storeProcedure2('TransferFundClient', {
              p_client_id: data.id,
              p_transaction_type_id: 8,
              p_ref_no: refNo.toUpperCase(),
              p_amount: transferAmount,
              p_remarks: remarks || selectedRemark
            }).then(async response => {
              if (response.data[0].Status == "202") {
                let form = new FormData();
                form.append("ReferenceNo", refNo.toUpperCase());
                form.append("TraceNo", formSeqNo);
                form.append("PdlNumber", pdlNumber);
                form.append("PdlName", `${firstName} ${lastName}`);
                form.append("Amount", transferAmount);
                form.append("Remarks", remark);
                form.append("Base64File", attachmentRelease);
                form.append("ContentType", attachmentContentType);
                form.append("FileName", `CashRelease_${refNo.toUpperCase()}.${fileExtension}`);
                await adminServices.emailApproval(form).then(async response => {
                  setIsSuccess(true);
                  setShowAlert2(true);
                  setAlertMessage2("PDL Cash Out Request has been submitted Ref No: " + refNo.toUpperCase());
                  let attachmentData = {
                    attachmentType: "Cash Release",
                    refNo: refNo.toUpperCase(),
                    attachment1: attachmentRelease
                  };
                  await adminServices.postData("attachments", attachmentData).then(async result => {
                    if (result.status == 200) {}
                  }).catch(e => {
                    //console.log('attachment error',e);
                    // setLoading(false);
                  });
                }).catch(error => {}).finally(() => {
                  setLoading(false);
                });
              } else {
                setShowAlert2(true);
                setAlertMessage2("Error while transferring funds to IPX. Please try again later.");
                setIsSuccess(false);
              }
            }).catch(error => {
              if (error.status === 401) {
                window.location.href = "/";
              }
            }).finally(() => {
              setMakeTransfer(false);
            });
          }
        }
      }).catch(e => {});
    }
  };
  const resetProfile = async () => {
    if (!isAdmin) {
      setAlertMessage("Unauthorized Access");
      setShowAlert(true);
      return;
    }
    var conf = window.confirm("Are you sure you want to reset this PDL Profile? This action cannot be undone.");
    if (!conf) {
      return;
    }
    setIsReset(true);
    var form = data;
    form.firstName = firstName;
    form.middleName = middleName;
    form.lastName = lastName;
    form.dob = dob;
    form.gender = gender;
    form.facilityNumber = facilityNumber;
    form.pin = null;
    form.statusId = statusId;
    form.leftFingerPrint = null;
    form.rightFingerPrint = null;
    form.quadrant = quadrant;
    form.regdate = new Date();
    delete form.walletAmount;
    setShowConfirm(false);
    await adminServices.updatePDL(form).then(r => {
      if (r.status === 204) {
        setAlertMessage("PDL Profile Reset Successfully");
        setShowAlert(true);
      }
    }).catch(e => {
      if (e.response.status === 401) {
        window.location.href = "/";
      } else {
        setAlertMessage(e.response.message);
        setShowAlert(true);
      }
    });
  };
  const handleClose = () => {
    setShowAlert(false);
    setShowAlert2(false);
    if (isSuccess) {
      window.location.href = "/pdl-management";
    }
  };
  const handleFileChange = e => {
    const file = e.target.files[0];
    if (!file) return;
    const contentType = file.type; // e.g. "application/pdf", "image/png"
    const ext = file.name.split('.').pop().toLowerCase(); // e.g. "pdf", "png"

    const reader = new FileReader();
    reader.onloadend = () => {
      setAttachmentRelease(reader.result); // This is the base64 string
      setAttachmentContentType(contentType);
      setFileExtension(ext);
      //console.log('Base64 Image:', reader.result);
    };
    reader.readAsDataURL(file); // Converts to base64
  };
  return <div className="container">
        <LoadingModal show={loading} message={"Loading PDL Transactions..."} />
        <AlertModal show={showAlert2} title="Surrender Cash To PDL" message={alertMessage2} onClose={handleClose} />
        <Modal style={customStyles} isOpen={makeTransfer} onRequestClose={() => {
      setMakeTransfer(false);
    }}>
            <div className="card">
                <div className="card-header">Surrender Cash to PDL</div>
                <div className="card-body d-flex flex-column align-item-center">
                    <div className=" d-flex flex-column justify-content-center">
                      <InputText1 title={"Amount to Transfer"} onChange={e => {
              setValidationMessage("");
              setIsValidate(true);
              if (e.target.value == "e") {
                setIsValidate(false);
                setValidationMessage("Invalid Amount");
              }
              if (e.target.value == "") {
                setIsValidate(false);
                setValidationMessage("Cash Out Amount should be at least 1");
              }
              if (e.target.value <= 0) {
                setIsValidate(false);
                setValidationMessage("Cash Out Amount should be at least 1");
              }
              if (e.target.value > data.walletAmount) {
                setIsValidate(false);
                setValidationMessage("Cash Out Amount cannot be greater than PDL Wallet");
              }
              setTransferAmount(e.target.value);
            }} value={transferAmount} type="number" />
                    </div>

                    <div className=" d-flex flex-column justify-content-center">
                      <InputText1 title={"Form Sequence Number"} onChange={e => {
              const regex = /^[a-zA-Z0-9]*$/;
              if (regex.test(e.target.value)) {
                setIsValidate(true);
                setFormSeqNo(e.target.value.toUpperCase());
              }
            }} value={formSeqNo} />
                    </div>

                    
                    <Dropdown title={"Remarks"} data={OptionRemarks} value={selectedRemark} onChange={e => {
            // if(e.target.value==""){
            //     setIsValidate(false);
            //     setValidationMessage("Please select a reason");
            //     return;
            // }

            setSelectedRemark(e.target.value);
            setRemark(e.target.value);
            if (e.target.valule == "Others") {
              setRemark('');
            }
          }} />


                    {selectedRemark == "Others" && <div className=" d-flex flex-column justify-content-center">
                      <InputText1 title={"Specify a reason"} onChange={e => {
              setIsValidate(true);
              setRemark(e.target.value);
            }} value={remark} placeholder={""} />
                    </div>}

                    <div className="d-flex flex-column mb-3 px-4">
                        <p className="semibold text-danger">{"Attach Document(Required)"}</p>
                        <input className="r form-control btn btn-primary" type="file" accept="image/*" onChange={handleFileChange} style={{
              color: 'blue',
              backgroundColor: "#fff"
            }}></input>
                        
                        </div>

                    <div className="text-danger">
                        {!isValidated && validationMessage}
                    </div>
                </div>
                <div className="card-footer d-flex justify-content-end">
                    <Button variant={"success"} onClick={handleSubmit}>Submit</Button>
                    &nbsp;
                    <Button variant={"danger"} onClick={() => {
            setMakeTransfer(false);
          }}>Cancel</Button>
                </div>
            </div>
        </Modal>
        <VoidModal toVoid={toVoid} voidEvent={voidTransaction} refNo={voidRefNo} show={showVoid} onClose={() => {
      setShowVoid(false);
    }} />
        <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '20px'
    }}>
            <div>
                <BackIcon style={{
          width: "50px",
          height: "50px",
          background: 'transparent',
          marginRight: '20px'
        }} onClick={() => {
          navigate('/pdl-management');
        }} />
                <ProfileIcon style={{
          width: "50px",
          height: "50px",
          marginRight: "10px",
          background: 'transparent'
        }} />
                {firstName} {lastName}

                &nbsp;| Wallet Balance: {formatCurrency(walletAmount)}
                &nbsp;| <span className={`dlt-status-badge ${dltStatus.tone}`} title={dltStatus.message}>{dltStatus.label}</span>
            </div>

            <div className="d-flex justify-content-end w-50">
                {isAdmin && !locked && <div className="d-flex justify-content-end">
                    <Button variant={"warning"} size={"lg"} onClick={resetProfile}> Reset Profile </Button>
                </div>}
                    &nbsp;
                <div className="d-flex justify-content-end">
                    <Button variant={"primary"} size={"lg"} onClick={handleTransfer}> Surrender Cash to PDL </Button>
                </div>
            </div>
        </div>
        <br></br>
        <ConfirmationDialog title={"Void Transaction"} show={confirmVoid} message={voidMessage} onCancel={() => {
      setConfirmVoid(false);
    }} onConfirm={() => {
      voidTransaction();
    }}>

        </ConfirmationDialog>
        <AlertModal show={showAlert} title={"PDL Updates"} onClose={() => {
      setShowAlert(false);
      if (isReset) {
        navigate('/pdl-management');
      }
    }} message={alertMessage}>
        </AlertModal>
        <ConfirmationDialog show={showConfirm} title={"PDL Profile"} message={"Are you sure you want to update the PDL Profile?"} onCancel={() => {
      setShowConfirm(false);
    }} onConfirm={() => {
      updateClient();
    }}></ConfirmationDialog>
        <div style={{
      display: "flex",
      flexDirection: 'row'
    }}>
            <form className="pdl-info row g-3" style={{
        width: '100%'
      }} onSubmit={e => {
        e.preventDefault();
        setShowConfirm(true);
      }}>
                <div className="col-12 d-flex align-items-center">
                    <div className="me-3"><span className="fw-bold">PDL Number:</span></div>
                    <div>{pdlNumber}</div>
                </div>

                <div className="col-md-3">
                    <label className="form-label">First Name</label>
                    <input className="form-control" type="text" value={firstName} onChange={e => {
            const regex = /^[a-zA-Z0-9]*$/;
            if (regex.test(e.target.value)) {
              setFirstName(e.target.value);
            }
          }} />
                </div>

                <div className="col-md-3">
                    <label className="form-label">Middle Name</label>
                    <input className="form-control" type="text" value={middleName} onChange={e => {
            const regex = /^[a-zA-Z0-9]*$/;
            if (regex.test(e.target.value)) {
              setMiddleName(e.target.value);
            }
          }} />
                </div>

                <div className="col-md-3">
                    <label className="form-label">Last Name</label>
                    <input className="form-control" type="text" value={lastName} onChange={e => {
            const regex = /^[a-zA-Z0-9]*$/;
            if (regex.test(e.target.value)) {
              setLastName(e.target.value);
            }
          }} />
                </div>

                <div className="col-md-2">
                    <label className="form-label">Suffix</label>
                    <select className="form-select" value={suffix} onChange={e => {
            setSuffix(e.target.value);
          }}>
                        <option value=''>Select Suffix</option>
                        <option value='Jr'>Jr</option>
                        <option value='Sr'>Sr</option>
                        <option value='II'>II</option>
                        <option value='III'>III</option>
                        <option value='IV'>IV</option>
                        <option value='V'>V</option>
                    </select>
                </div>

                <div className="col-md-3">
                    <label className="form-label">Spending Limit</label>
                    
                    <input className="form-control" type="text" value={customSpendingLimit} onChange={e => {
            setCustomSpendingLimit(e.target.value);
          }} />
                </div>

                <div className="col-md-2">
                    <label className="form-label">Date Of Birth</label>
                    <input className="form-control" type='date' value={dob} onChange={e => {
            setDob(e.target.value);
          }} />
                </div>

                <div className="col-md-2">
                    <label className="form-label">Gender</label>
                    <select className="form-select" value={gender} onChange={e => {
            setGender(e.target.value);
          }}>
                        <option value='M'>Male</option>
                        <option value='F'>Female</option>
                    </select>
                </div>

                <div className="col-md-2">
                    <label className="form-label">Facility Number</label>
                    <input className="form-control" type='text' value={facilityNumber} onChange={e => {
            const regex = /^[a-zA-Z0-9]*$/;
            if (regex.test(e.target.value)) {
              setFacilityNumber(e.target.value);
            }
          }} />
                </div>

                <div className="col-md-2">
                    <label className="form-label">Colony</label>
                    <select className="form-select" value={colonyId} onChange={e => {
            setColonyId(e.target.value);
          }}>
                        {colonies && colonies.map(colony => <option key={colony.colony_iid} value={colony.colony_id}>
                                {colony.colony_name}
                            </option>)}
                    </select>
                </div>

                <div className="col-md-2">
                    <label className="form-label">Facilities/ Quadrant</label>
                    <select className="form-select" value={quadrant} onChange={e => {
            setQuadrant(e.target.value);
          }}>
                        {facilities && facilities.map(facility => <option key={facility.FacilityId} value={facility.Facility}>
                                {facility.Facility}
                            </option>)}
                    </select>
                </div>

                <div className="col-md-2">
                    <label className="form-label">Status</label>
                    <select className="form-select" value={statusId} onChange={e => {
            setStatusId(parseInt(e.target.value));
          }}>
                        {options && options.map(option => <option key={option.status_id} value={option.status_id}>
                                {option.description}
                            </option>)}
                    </select>
                </div>

                {!noPin && <div className="col-md-4 d-flex align-items-end">
                        <div>
                            <div className="form-label mb-1"><span className="fw-bold">Enable Pin?</span></div>
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="pinEnabled" id="pinYes" value={"Yes"} onChange={() => {
                setPin(generateRandomNumber());
              }} />
                                <label className="form-check-label" htmlFor="pinYes">Yes</label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="pinEnabled" id="pinNo" value={"No"} onChange={() => {
                setPin('');
              }} />
                                <label className="form-check-label" htmlFor="pinNo">No</label>
                            </div>
                        </div>
                    </div>}

                <div className="col-12 d-flex justify-content-end">
                    <Button2 text={"Update PDL"} onClick={() => {
            if (locked) {
              setAlertMessage("PDL is not fully registered. Please complete onboarding process before updating profile.");
              setShowAlert(true);
              return;
            }
            setShowConfirm(true);
          }} style={{
            width: "200px",
            backgroundColor: "#61dd48"
          }} />
                </div>
            </form>
        </div>
        <div style={{
      width: '100%'
    }}>
            <br />
            <h3>PDL Transactions</h3>
            <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 8
      }}>
                <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          width: '100%'
        }}>
                    <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8
          }}>
                        <InputText1 title={"Date From"} type="date" value={startDate} onChange={e => setStartDate(e.target.value)} />
                        <InputText1 title={"Date To"} type="date" value={endDate} onChange={e => setEndDate(e.target.value)} />
                        <div style={{
              marginTop: 18
            }}>
                            <Button variant={"primary"} onClick={async () => {
                setOffset(0);
                if (mode === 'all') await getClientTransactions();else if (mode === 'padala') await getClientPadala();else if (mode === 'purchases') await getClientPurchases();else if (mode === 'void') await getClientVoids();
              }}>Filter</Button>
                        </div>
                    </div>
                    <div style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center'
          }}>
                        {(startDate || endDate) && <div style={{
              fontSize: '1rem',
              fontWeight: 600
            }}>Total Amount on Selected Range: {formatCurrency(Math.abs(totalRangeAmount))}</div>}
                    </div>
                    <div style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'flex-end'
          }}>
                        <div style={{
              width: '320px'
            }}>
                            <SearchBar placeholder="Search Transaction" onChange={e => {
                const value = e.target.value.toLowerCase();
                const filtered = transactions ? transactions.filter(item => Object.keys(item).some(key => item[key] && item[key].toString().toLowerCase().includes(value.toLowerCase()))) : [];
                setFilteredData(filtered);
              }} />
                        </div>
                    </div>
                </div>
            </div>
            
            {/* Search + Mode buttons row */}
            <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 8
      }}>
                <div className="flexRow filterDiv" style={{
          flex: 1
        }}>
                    <SearchBar placeholder="Search Transaction" onChange={e => {
            const value = e.target.value.toLowerCase();
            const filtered = transactions.filter(item => Object.keys(item).some(key => item[key] && item[key].toString().toLowerCase().includes(value.toLowerCase())));
            setFilteredData(filtered);
          }} />
                </div>
                <div className="btn-group">
                    <input type="button" value={"All Transactions"} className={mode === "all" ? "btn btn-info btn-xs" : " btn btn-primary btn-xs"} onClick={async () => {
            setMode("all");
            setOffset(0);
            await getClientTransactions();
          }} />
                    <input type="button" value={"Padala"} className={mode === "padala" ? "btn btn-info btn-xs" : " btn btn-primary btn-xs"} onClick={async () => {
            setMode("padala");
            setOffset(0);
            await getClientPadala();
          }} />
                    <input type="button" value={"Purchases"} className={mode === "purchases" ? "btn btn-info btn-xs" : " btn btn-primary btn-xs"} onClick={async () => {
            setMode("purchases");
            setOffset(0);
            await getClientPurchases();
          }} />
                    <input type="button" value={"Void Transactions"} className={mode === "void" ? "btn btn-info btn-xs" : " btn btn-primary btn-xs"} onClick={async () => {
            setMode("void");
            setOffset(0);
            await getClientVoids();
          }} />
                </div>
            </div>

            <div className="d-flex justify-content-end align-items-center mb-1">
                <Button variant={"light"} size={"sm"} onClick={() => {
          if (offset > 0) {
            setOffset(prev => prev - limit);
          }
        }}> 
                    <i className='fa fa-arrow-left'></i>
                </Button>
                <div>{`${offset + 1} - ${offset + limit < totalRecords ? offset + limit : totalRecords}`} of {totalRecords}</div>
                <Button variant={"light"} size={"sm"} onClick={() => {
          if (offset + limit < totalRecords) {
            setOffset(prev => prev + limit);
          }
        }}>
                    <i className='fa fa-arrow-right'></i>
                </Button>
            </div>

            <div className="mt-2">
                <DataTable columns={columns} data={filteredData} pagination={false} overflowY="scroll" striped persistTableHead highlightOnHover />
            </div>
        </div>
    </div>;
};
export default withAuthorization(PDLTransactions, 3);